import {types} from "../actions";

const initialState = {
  groupName: '',
  checkedSites: [],
  selectedMembers: [],
};

const addGroupReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SET_GROUP_NAME:
      return {
        ...state,
        groupName: action.payload,
      };
    case types.SET_CHECKED_SITES:
      return {
        ...state,
        checkedSites: action.payload,
      };
    case types.SET_SELECTED_MEMBERS:
      return {
        ...state,
        selectedMembers: action.payload,
      };
    default:
      return state;
  }
};

export default addGroupReducer;